import styled from 'styled-components';
import React from 'react';
import { ArrowDropDown } from '@material-ui/icons';
import { API_ROOT } from 'Api/Routes';

const Button = styled.div`
  &&& {
    background: transparent;
    border: 0;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: transparent !important;
    }
  }
`;

const CustomArrowDown = styled(ArrowDropDown)`
  &&& {
    fill: ${({ theme }) => theme.palette.blue.light};
  }
`;

const User = styled.img`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.blue.light};
  border: 0;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  font-size: 1.25rem;
  color: #fff;
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;
  justify-content: center;
  margin-bottom: 0 !important;
  text-align: center;
  object-fit: cover;
`;

const SettingsButton = props => (
  <Button {...props}>
    {Boolean(props.avatar) ? (
      <User src={`${API_ROOT}/asset/${props.avatar}`} />
    ) : (
      <User
        src={'http://www.korcula-guide.com/wp-content/uploads/dummy/user.jpg'}
      />
    )}

    <CustomArrowDown />
  </Button>
);

export default SettingsButton;
